import { useParams } from "react-router-dom";
import constants from "../../constants/constants";
import './BlogDetail.css'

export default function BlogDetail() {
  const { slug } = useParams();

  const blog = constants.blogs.find(
    (blog) => blog.slug === slug
  );

  if (!blog) {
    return <h1>Blog not found</h1>;
  }

  return (
    <article className="blog-detail">

      <h1>{blog.title}</h1>

      <p className="blog-excerpt">
        {blog.excerpt}
      </p>

      <img
        src={blog.image}
        alt={blog.title}
      />

      <div
        className="blog-content"
        dangerouslySetInnerHTML={{
          __html: blog.content
        }}
      />

    </article>
  );
}